// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3-bGJ","description":"PatientConsentPreview_description__ELEOg"};